import {SupportedLocales} from '#types';

export const importSourcesLang = {
  [SupportedLocales.EN]: {
    title: 'Ingest',
    subtitle: 'View and Manage Ingest Connections.',
    table: {
      ariaLabel: 'Ingest connections table',
      loadingAriaLabel: 'Loading ingest connections',
      search: 'Search',
      type: 'Type',
      name: 'Name',
      syncFrequency: 'Sync Frequency',
      status: 'Status',
      createdAt: 'Created At',
      emptyValue: '-',
      empty: 'There are no ingest connections.',
      emptyCaption: "Looks like you haven't added an ingest connection.",
      emptySearch: 'There are no ingest connections matching your search.',
      connect: 'New Ingest Connection',
      processing: 'Processing',
      active: 'Active',
      finishConfiguration: 'Finish Configuration',
    },
    teaser: {
      mainText: 'Activate Ingest (Easy Button)',
      subText:
        'Reach out to your GrowthLoop Solutions Architect to unlock ingest (Easy Button)',
      confirmationText:
        'Please send your inquiry email to support@growthloop.com and we will get back to you shortly.',
      contactSubject: 'Easy Button Inquiry',
      contactBody:
        'I am interested in connecting my data through the easy button for my organization. Could you please provide me with detailed information about how to get started?',
    },
  },
  [SupportedLocales.ES]: {
    title: 'Ingesta',
    subtitle: 'Ver y gestionar conexiones de ingesta.',
    table: {
      ariaLabel: 'Tabla de conexiones de ingesta',
      loadingAriaLabel: 'Cargando conexiones de ingesta',
      search: 'Buscar',
      type: 'Tipo',
      name: 'Nombre',
      syncFrequency: 'Frecuencia de sincronización',
      status: 'Estado',
      createdAt: 'Fecha de creación',
      emptyValue: '-',
      empty: 'No hay conexiones de ingesta.',
      emptyCaption: 'Parece que aún no has agregado una conexión de ingesta.',
      emptySearch:
        'No hay conexiones de ingesta que coincidan con tu búsqueda.',
      connect: 'Nueva conexión de ingesta',
      processing: 'Procesando',
      active: 'Activo',
      finishConfiguration: 'Finalizar configuración',
    },
    teaser: {
      mainText: 'Activar Ingesta (Easy Button)',
      subText:
        'Contacta a tu Arquitecto de Soluciones de GrowthLoop para activar Ingesta (Easy Button)',
      confirmationText:
        'Por favor, envía tu correo de consulta a support@growthloop.com y te responderemos lo antes posible.',
      contactSubject: 'Consulta sobre activación de Easy Button',
      contactBody:
        'Estoy interesado en conectar mis datos a través del botón fácil para mi organización. ¿Podrías proporcionarme información detallada sobre cómo comenzar?',
    },
  },
};
